<template>
    <div class="w-full">
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="mx-auto w-[70%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                        <h2 class="text-3xl font-medium text-center text-gray-700 mt-24 mb-[70px] underline">TRAVEL AUTHORIZATION</h2>
                        <p class="text-gray-700 mt-14 font-semibold">
                            NAME: {{ name ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            FUNCTION: {{ functions ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            PERIOD: {{ debut ?? "" }} - {{ fin }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            PLACE: {{ place ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            SUBJECT: {{ subject ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            TRANSPORTATION: {{ transportation ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            BUDGET: {{ budget ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-28 text-right mr-36">
                            DATE
                        </p>
                        <p class="text-gray-700 mt-28 font-semibold text-right mr-28">
                            SIGNATURE
                        </p>

                        <div class="flex justify-end">
                            <div class="w-[300px] h-[150px] rounded-xl border border-dashed mt-5 flex flex-col items-center justify-center p-3">
                                <p v-if="!signature" class="font-extralight text-black">Pas de signature</p>
                                <img v-else :src="getPath" :alt="signature" class="h-full object-contain">
                            </div>
                        </div>
                        

            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "TravelAuthValid",
    components: {Loader2},
    data() {
        return {
            id: "",
            asSend: false,
            name: null,
            functions: null,
            debut: null,
            fin: null,
            place: null,
            subject: null,
            transportation: null,
            budget: null,
            signature: null
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
        this.signature = localStorage.getItem("signature") ?? undefined;
    },
    computed:{
        getPath(){
            return `https://backend-ehr.iugb-ci.com/public/image/${this.signature}`;
        }
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.functions= JSON.parse(data.data["data"]["content"]).function
                    this.debut= JSON.parse(data.data["data"]["content"]).debut
                    this.fin= JSON.parse(data.data["data"]["content"]).fin
                    this.place= JSON.parse(data.data["data"]["content"]).place
                    this.subject= JSON.parse(data.data["data"]["content"]).subject
                    this.transportation= JSON.parse(data.data["data"]["content"]).transportation
                    this.budget= JSON.parse(data.data["data"]["content"]).budget
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            if(!this.signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : this.signature
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>